exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "body {\n  background-color: #172894;\n  color: whitesmoke;\n  font-family: \"Microsoft YaHei\" ! important;\n  font-size: 30px;\n}\n.header {\n  height: 120px;\n  line-height: 120px;\n  font-size: 45px;\n}\n.content {\n  padding-top: 40px;\n}\n.footer {\n  height: 100px;\n  line-height: 100px;\n  font-size: 25px;\n  padding-left: 30px;\n}\n.jss-transparent {\n  background-color: rgba(255, 255, 255, 0.15);\n  /* IE9、标准浏览器、IE6和部分IE7内核的浏览器(如QQ浏览器)会读懂 */\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/less-loader/dist/cjs.js!./src/views/gateCheck/Check.less
// module id = TIRz
// module chunks = 1